export const DEFAULT_OPTIONS_WITH_API_KEY = {
    useApiKey: true,
};

export const HTTPAction = {
    GET: 'GET',
    POST: 'POST',
    PATCH: 'PATCH',
    DELETE: 'DELETE',
    PUT: 'PUT',
} as const;
